<div class="add-member-dialog">

  <h2 class="dialog-title">{{ 'fee.actions.add_member' | translate }}</h2>

  @if (loadingGroups) {
    <div class="loading-row">
      <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    </div>
  } @else {
    <div class="page-surface">
      <button type="button" class="add-member-link" (click)="onAddMemberClick()">
        + {{ 'fee.actions.add_member' | translate }}
      </button>

      @for (memberGroup of memberFormControls; track memberGroup; let i = $index) {
      <div class="section-card member-entry-card">
        <button type="button" class="btn-close-card" [attr.aria-label]="'fee.remove_member_draft' | translate" (click)="removeMemberCard(i)">
          <mat-icon>close</mat-icon>
        </button>
        <form [formGroup]="memberGroup" class="member-form" (ngSubmit)="saveMember(i)">

          @if (!memberMetas[i].expanded) {
            <div class="member-collapsed-row">
              <button type="button"
                      class="icon-btn icon-btn-plain row-toggle"
                      [attr.aria-label]="'fee.expand_section' | translate"
                      (click)="toggleMemberCard(i)"
                      [class.is-collapsed]="!memberMetas[i].expanded">
                <mat-icon>arrow_drop_up</mat-icon>
              </button>
              <div class="member-data-col">
                <span class="member-data-label">{{ 'fee.user_name' | translate }}</span>
                <span class="member-data-value">{{ getMemberControl(i, 'name').value || '—' }}</span>
              </div>
              <div class="member-data-col">
                <span class="member-data-label">{{ 'fee.group' | translate }}</span>
                <span class="member-data-value">{{ getSelectedGroupName(i) }}</span>
              </div>
              <div class="member-data-col">
                <span class="member-data-label">{{ 'fee.subgroup' | translate }}</span>
                <span class="member-data-value">{{ getSelectedSubgroupName(i) }}</span>
              </div>
              <div class="member-data-col">
                <span class="member-data-label">{{ 'fee.frequency' | translate }}</span>
                <span class="member-data-value">{{ frequencyLabel(getMemberControl(i, 'frequency').value) || '—' }}</span>
              </div>
            </div>
          }

          @if (memberMetas[i].expanded) {
            <div class="form-row">
              <button type="button"
                      class="icon-btn icon-btn-plain row-toggle"
                      [attr.aria-label]="'fee.collapse_section' | translate"
                      (click)="toggleMemberCard(i)"
                      [class.is-collapsed]="!memberMetas[i].expanded">
                <mat-icon>arrow_drop_up</mat-icon>
              </button>

              <mat-form-field appearance="fill">
                <mat-select formControlName="groupId" [placeholder]="'fee.group' | translate" (selectionChange)="onGroupChange(i, $event.value)">
                  @for (g of groups; track g.id) {
                    <mat-option [value]="g.id">{{ g.name }}</mat-option>
                  }
                </mat-select>
                @if (getMemberControl(i, 'groupId').invalid && (getMemberControl(i, 'groupId').touched || submitAttemptedByIndex[i])) {
                  <mat-error>{{ 'fee.validation.select_group' | translate }}</mat-error>
                }
              </mat-form-field>

              <div>
                <mat-form-field appearance="fill" class="w-full">
                  <mat-select formControlName="subgroupId" [placeholder]="'fee.subgroup' | translate" (selectionChange)="onSubgroupChange(i, $event.value)">
                    @for (sg of filteredSubgroupsByIndex[i]; track sg.id) {
                      <mat-option [value]="sg.id">{{ sg.name }}</mat-option>
                    }
                  </mat-select>
                  @if (getMemberControl(i, 'subgroupId').invalid && (getMemberControl(i, 'subgroupId').touched || submitAttemptedByIndex[i])) {
                    <mat-error>{{ 'fee.validation.select_subgroup' | translate }}</mat-error>
                  }
                </mat-form-field>
                @if (duplicateSubgroupErrors[i]) {
                  <div class="field-error-hint">{{ 'fee.validation.subgroup_exists_in_multiple_groups' | translate }}</div>
                }
              </div>
            </div>

            <div class="form-row">
              <span></span>
              <mat-form-field appearance="fill">
                <input matInput formControlName="name" maxlength="50" [placeholder]="'fee.user_name' | translate" />
                @if ((getMemberControl(i, 'name').hasError('minlength') || getMemberControl(i, 'name').hasError('maxlength')) && getMemberControl(i, 'name').touched) {
                  <mat-error>{{ 'fee.validation.name_2_50' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-select formControlName="frequency" [placeholder]="'fee.frequency' | translate">
                  @for (freq of frequencyTypes; track freq) {
                    <mat-option [value]="freq">{{ frequencyLabel(freq) }}</mat-option>
                  }
                </mat-select>
                @if (getMemberControl(i, 'frequency').invalid && (getMemberControl(i, 'frequency').touched || submitAttemptedByIndex[i])) {
                  <mat-error>{{ 'fee.validation.select_frequency' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-row">
              <span></span>
              <mat-form-field appearance="fill">
                <input matInput formControlName="passportId" maxlength="20" [placeholder]="'fee.passport_or_id_card' | translate" />
                @if (getMemberControl(i, 'passportId').hasError('alphanumeric') && getMemberControl(i, 'passportId').touched) {
                  <mat-error>{{ 'fee.validation.only_letters_numbers' | translate }}</mat-error>
                }
                @if (getMemberControl(i, 'passportId').hasError('maxlength') && getMemberControl(i, 'passportId').touched) {
                  <mat-error>{{ 'fee.validation.max_20_characters' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="fill" class="dob-field">
                <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth" [placeholder]="('fee.date_of_birth' | translate) + ' (Optional)'" readonly />
                <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
                <mat-datepicker #dobPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-row">
              <span></span>
              <div class="phone-field">
                <ngx-intl-tel-input
                  formControlName="phone"
                  [cssClass]="'form-control form-control-lg confirm-password-reduced-placeholder-width form-tel' + ((getMemberControl(i, 'phone').invalid && getMemberControl(i, 'phone').touched) ? ' has-error' : '')"
                  [preferredCountries]="preferredCountries"
                  [selectedCountryISO]="defaultCountryISO"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="false"
                  customPlaceholder="77 123456"
                  [searchCountryFlag]="false"
                  [phoneValidation]="false"
                  [separateDialCode]="true"
                  [numberFormat]="phoneNumberFormat"
                  (blur)="validatePhoneNumber(i)">
                </ngx-intl-tel-input>
                @if (invalidPhoneMessages[i] && getMemberControl(i, 'phone').touched) {
                  <div class="validation">
                    <small>{{ invalidPhoneMessages[i]! | translate }}</small>
                  </div>
                }
              </div>

              <mat-form-field appearance="fill">
                <input matInput formControlName="email" type="email" [placeholder]="'fee.email' | translate" />
                @if (getMemberControl(i, 'email').hasError('required') && getMemberControl(i, 'email').touched) {
                  <mat-error>{{ 'fee.validation.email_required' | translate }}</mat-error>
                }
                @if (getMemberControl(i, 'email').hasError('email') && getMemberControl(i, 'email').touched) {
                  <mat-error>{{ 'fee.validation.invalid_email' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-row discount-section-row">
              <span></span>
              <div class="discount-section">
                <div class="discount-grid">
                  <mat-form-field appearance="fill" class="discount-type-field">
                    <mat-select formControlName="discountType"
                                [placeholder]="'fee.discount_type_optional' | translate"
                                (openedChange)="onMemberDiscountSelectOpened(i, $event)">
                      @for (type of discountTypes; track type) {
                        <mat-option [value]="type" (click)="onMemberDiscountOptionClick(i, type)">{{ 'fee.subgroups.discount_types.' + type | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div class="discount-value-cell">
                    <mat-form-field appearance="fill">
                      <input matInput type="number" formControlName="discountValue" min="0" class="no-spinner"
                             inputmode="numeric" (keydown)="onMemberDiscountKeyDown($event)" (paste)="onMemberDiscountPaste(i, $event)"
                             [placeholder]="'fee.discount_optional' | translate" />
                    </mat-form-field>
                    <div class="discount-error-stack">
                      @if (getMemberControl(i, 'discountType').hasError('discountTypeRequired')) {
                        <mat-error>{{ 'fee.validation.discount_type_required' | translate }}</mat-error>
                      }
                      @if (getMemberControl(i, 'discountValue').hasError('notInteger')) {
                        <mat-error>{{ 'fee.validation.discount_whole_number' | translate }}</mat-error>
                      }
                      @if (getMemberControl(i, 'discountValue').hasError('maxPercent')) {
                        <mat-error>{{ 'fee.validation.discount_percent_max' | translate }}</mat-error>
                      }
                      @if (getMemberControl(i, 'discountValue').hasError('exceedsPrice')) {
                        <mat-error>{{ 'fee.validation.discount_less_than_price' | translate }}</mat-error>
                      }
                    </div>
                  </div>

                  <div class="price-summary">
                    <span class="price-label">{{ 'fee.price' | translate }} - {{ memberBasePrice(i) | number:'1.0-0' }} ֏</span>
                    <span class="final-price-label">{{ 'fee.final_price' | translate }} - {{ memberFinalPrice(i) | number:'1.0-0' }} ֏</span>
                  </div>
                </div>

                <mat-form-field appearance="fill" class="discount-reason-field">
                  <input matInput formControlName="discountReason" maxlength="100"
                         (keydown)="onMemberDiscountReasonKeyDown($event)" (paste)="onMemberDiscountReasonPaste(i, $event)"
                         [placeholder]="'fee.discount_reason_optional' | translate" />
                  @if (getMemberControl(i, 'discountReason').hasError('maxlength')) {
                    <mat-error>{{ 'fee.validation.max_100_characters' | translate }}</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="save-member-row">
              <button type="submit" class="btn-save-member">
                {{ 'fee.save_member' | translate }}
              </button>
            </div>
          }
        </form>
      </div>
      }

      <div class="dialog-actions">
        <button class="btn-cancel" type="button" (click)="cancel()">
          {{ 'Cancel' | translate }}
        </button>
        <button class="btn-save"
                type="button"
                [disabled]="!atLeastOneMemberSaved || submitting"
                (click)="save()">
          @if (submitting) {
            <mat-progress-spinner mode="indeterminate" diameter="18" class="spinner-inline"></mat-progress-spinner>
          }
          {{ 'user_card.save' | translate }}
        </button>
      </div>
    </div>
  }
</div>
